<template>
  <div class="wrapper">
    <page-header/>
    <div class="content container">
      <page-loader v-if="loading"/>
      <div v-else class="row">
        <div class="col-12 col-md-7">
          <client-details :schedule-id="scheduleId"/>
          <appointments :schedule-id="scheduleId" :sequence="sequence"/>
          <payments v-if="schedulePaymentAccount" :schedule-id="scheduleId" :reference="reference" :sequence="sequence"/>
        </div>
        <div class="col-12 col-md-5">
          <img class="w-100" src="@/assets/Images/appointment.png" alt="Appointment">
        </div>
      </div>
    </div>
    <page-footer/>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { LogoCacheMixin } from '@/mixins/Logo/LogoCacheMixin'
import { SchedulePaymentAccountCacheMixin } from '@/mixins/Payment/SchedulePaymentAccountCacheMixin'
import Appointments from './Appointments.vue'
import ClientDetails from './ClientDetails.vue'
import Payments from './Payments.vue'
import PageLoader from '../Loading/PageLoader.vue'
import PageHeader from '../Layout/PageHeader.vue'
import PageFooter from '../Layout/PageFooter.vue'

export default {
  name: 'AppointmentPage',
  mixins: [LogoCacheMixin, SchedulePaymentAccountCacheMixin],
  data () {
    return {
      sequence: 0
    }
  },
  methods: {
    ...mapMutations('PaymentTokens', [
      'setPaymentLoginRoute'
    ])
  },
  computed: {
    scheduleId () {
      return this.$route.query.id
    },
    sequenceNumber () {
      return parseInt(this.$route.query.sequence)
    },
    reference () {
      return this.selectedSiteId ? this.scheduleId + this.sequence : ''
    },
    loading () {
      return !!this.loadingSchedulePaymentAccount || !!this.loadingLogo
    }
  },
  components: {
    'client-details': ClientDetails,
    appointments: Appointments,
    payments: Payments,
    'page-loader': PageLoader,
    'page-header': PageHeader,
    'page-footer': PageFooter
  },
  created () {
    this.sequence = isNaN(this.sequenceNumber) ? 0 : this.sequenceNumber
    this.setPaymentLoginRoute('ClientAppointmentSchedule/' + this.scheduleId + '/PaymentUser/Login')
  }
}
</script>
